import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChooseContextComponent } from './ambassador/components/choose-context/choose-context.component';
import { BookingFinishedComponent } from './ambassador/components/booking-finished/booking-finished.component';
import { ConfirmSiteVisitComponent } from './ambassador/components/confirm-site-visit/confirm-site-visit.component';

import { SiteVisitBookComponent } from './ambassador/components/site-visit-book/site-visit-book.component';
import { SiteVisitTermsConditionsComponent } from './ambassador/components/site-visit-terms-conditions/site-visit-terms-conditions.component';
import { ScheduleOtherSiteVisitComponent } from './ambassador/components/schedule-other-site-visit/schedule-other-site-visit.component';

// Module is mapped to eo in AppModule (e.g. http://localhost:4000/#/eo )
const routes: Routes = [
  {
    path: 'oaa/book/:id',
    component: SiteVisitBookComponent,
    children: [
      //   { path: 'contact-info', component: BookingContactInfoComponent},
      //   { path: 'payment-terms', component: TermsComponent},
      //   { path: 'tc', component: TermsConditionsComponent},
      //   { path: 'request-access', component: BookingRequestAccessComponent},
      //   { path: 'payment', component: BookingPaymentComponent},
      //   { path: 'confirm', component: ConfirmComponent},
      //   { path: 'payment-result', component: PaymentResultComponent, data:{ workflowName:null}},
      //   { path: 'background-check', component: BookingBackgroundCheckComponent},
      //   { path: 'background-check-disclosure', component: BackgroundCheckDisclosureComponent},
      //   { path: 'background-check-auth', component: BackgroundCheckAuthorization},
      //   { path: 'introduction', component: BookingIntroductionComponent},
      //   { path: 'guests', component: BookingGuestsComponent},
      { path: 'cc', component: ChooseContextComponent },
      { path: 'tc', component: SiteVisitTermsConditionsComponent },
      { path: 'confirm', component: ConfirmSiteVisitComponent },
      { path: 'finished', component: BookingFinishedComponent },
      { path: 'schedule-other', component: ScheduleOtherSiteVisitComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExternalOrgRoutingModule {}
